/**
 * This should synchronise with au.com.finsyn.forms.acurityweb.NativeTaskRunner in the acurity project.
 */
export interface NativeTaskRunner {
	openPclFile(reportId: string): void;
	openPresenterView(reportId: string): void;
	authenticate(): boolean;
}

export function getNativeTaskRunner() {
	return (window as any).nativeTaskRunner as NativeTaskRunner;
}
